import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function CommIntroduction() {
    return (
        <React.Fragment>
            <p>
                If you encounter a problem with the <strong>Signiant Communication Service</strong>, the associated log
                files can assist when troubleshooting installation, initialization, or operational problems.
            </p>
            <p>The communication service logs are stored in different locations on Linux and Windows:</p>
            <p>
                <strong>Linux</strong>:{' '}
                <code className="language-text">/var/log/signiant/signiant-communication-service/</code> <br />
                <br />
                <strong>Windows</strong>:{' '}
                <code className="language-text">C:\Program Files\Signiant\logs\Communication Service\</code>
            </p>
            <p>
                The communication service can be configured to provide additional detail when troubleshooting issues by
                modifying the communication service configuration to adjust the log level.
            </p>
            <p>
                Unless otherwise specified by Signiant Support, set the log level to{' '}
                <code className="language-text">trace</code>.
            </p>
            <p>To set the log level:</p>
            <ol>
                <li>
                    Open the Signiant Communication Service configuration file in a text editor:
                    <br />
                    <br />
                    <p>
                        <strong>Linux</strong>:{' '}
                        <code className="language-text">
                            /usr/local/etc/signiant/signiant-communication-service-config.json5
                        </code>{' '}
                        <br />
                        <br />
                        <strong>Windows</strong>:{' '}
                        <code className="language-text">
                            C:\Program Files\Signiant\Communication Service\signiant-communication-service-config.json5
                        </code>
                    </p>
                </li>
                <li>Back up the existing JSON file by copying it to another location.</li>
                <li>Modify the JSON to include logging configuration:</li>
            </ol>
        </React.Fragment>
    );
}

CommIntroduction.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CommIntroduction);
